import React from 'react'
import AdviserProfile from '../AdviserProfile'
import MobileUnsupported from '../../MobileUnsupported/MobileUnsupported'
import { connect } from 'react-redux'
import Spinner from '../../../common/Spinners/Spinner'
import ErrorBoundary from '../../../common/ErrorBoundary/ErrorBoundary'
import { actions } from './adviserProfileEditorContainerActions'
import { Row, Col } from 'react-bootstrap'
import history from '../../../core/history'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types';

class AdviserProfileEditorContainer extends React.Component {
  static propTypes = {
    adviserId: PropTypes.number,
    profile: PropTypes.object.isRequired,
    hasPendingProfile: PropTypes.bool,
    agToken: PropTypes.string,
    adviserIsLoggedIn: PropTypes.bool.isRequired,
    administratorIsLoggedIn: PropTypes.bool.isRequired,
    fetchWorkInProgressProfile: PropTypes.func.isRequired,
    fetchPendingProfile: PropTypes.func,
    logAdviserIn: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    loginFailed: PropTypes.bool,
    editAll: PropTypes.func.isRequired,
    editingProfile: PropTypes.bool.isRequired,
    submitProfile: PropTypes.func.isRequired,
    cancelEditingProfile: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    submitted: PropTypes.bool.isRequired,
    edited: PropTypes.bool.isRequired,
    stopAll: PropTypes.func.isRequired,
    containerIsValid: PropTypes.bool.isRequired,
    fetchedContactNumberTypes: PropTypes.bool.isRequired,
    fetchContactNumberTypes: PropTypes.func.isRequired,
    showProfileLockedModal: PropTypes.func,
    hideProfileLockedModal: PropTypes.func,
    showModal: PropTypes.bool
  }

  constructor (props) {
    super(props)
    this.state = {fetchedProfile: false}
    this.contactAdviser = this.contactAdviser.bind(this)

    this.rateAdviser = this.rateAdviser.bind(this)

    this.extractToken = this.extractToken.bind(this)
  }

  componentDidMount () {
    const { adviserId, logAdviserIn } = this.props

    const queryString = history.location.search
    // A fresh ForgeRock token only arrives in the URL on the post-login redirect (?t=...).
    const freshToken = queryString.indexOf('?t=') === 0
      ? queryString.substring('?t='.length)
      : null

    if (!this.userIsLoggedIn && freshToken) {
      global.localStorage.setItem('base64token', JSON.stringify(freshToken))
      logAdviserIn(adviserId, freshToken)
      history.push(`/adviser/${this.props.adviserId}/profile/edit`)

      return
    }

    if (freshToken) {
      // Drop the one-time token out of the URL.
      history.push(`/adviser/${this.props.adviserId}/profile/edit`)
    }

    if (!this.props.fetchedContactNumberTypes) {
      this.props.fetchContactNumberTypes()
    }

    // On a refresh there is no ?t= token, and the server-rendered state can't read localStorage,
    // so adviserIsLoggedIn may be false even though the API session token is still stored. Load
    // the profile with that stored token instead of re-running the (now-expired) ForgeRock swap.
    const hasStoredSession = typeof global.localStorage !== 'undefined' &&
      global.localStorage.getItem('token')
    if ((this.userIsLoggedIn || hasStoredSession) && adviserId && !this.state.fetchedProfile) {
      this.fetchProfile()
    }
  }

  extractToken () {
    var agToken = this.props.agToken
    const queryString = history.location.search
    const queryStringToken = queryString.substring('?t='.length, queryString.length)
    if (queryStringToken !== null) {
      global.localStorage.setItem('base64token', JSON.stringify(queryStringToken))
    } else {
      var token = global.localStorage.getItem('base64token')

      if (token !== null) {
        agToken = token
      }
    }
    agToken = queryStringToken !== null ? queryStringToken : agToken
    return agToken
  }

  get userIsLoggedIn () {
    return this.props.adviserIsLoggedIn || this.props.administratorIsLoggedIn
  }

  fetchProfile () {
    this.props.fetchWorkInProgressProfile(this.props.adviserId)

    this.props.fetchPendingProfile(this.props.adviserId)

    this.setState({ fetchedProfile: true })
  }

  componentDidUpdate () {
    if (this.userIsLoggedIn && this.props.adviserId && !(this.state.fetchedProfile || this.props.fetchedContactNumberTypes)) {
      if (!this.props.fetchedContactNumberTypes) {
        this.props.fetchContactNumberTypes()
      }
      this.fetchProfile()
    }
  }

  contactAdviser () {
    history.push(`/adviser/${this.props.adviserId}/contact`, { adviser: this.props.profile })
  }

  rateAdviser () {
    history.push(`/adviser/${this.props.profile.adviserName}/${this.props.adviserId}/rate`, { adviser: this.props.profile })
  }

  render () {
    if (this.props.loginFailed) {
      return <Row>
        <Col xs={12}>
          <div style={{ padding: '60px 20px', textAlign: 'center', fontSize: '18px', lineHeight: '1.5', color: '#54595c' }}>
            Your adviser access has not yet been approved. Please contact your administrator.
          </div>
        </Col>
      </Row>
    }
    if (this.props.loading) {
      return <Spinner />
    }
    return <Row>
      <Col xs={12} className="d-block d-md-none">
        <MobileUnsupported />
      </Col>
      <Col sm={12} md={12} lg={12} className="d-none d-md-block">
        <ErrorBoundary>
          <AdviserProfile
            profile={this.props.profile}
            editAll={this.props.editAll}
            editingProfile={this.props.editingProfile}
            submitProfile={this.props.submitProfile}
            submittedProfile={this.props.submitted}
            submittingProfile={this.props.submitting}
            cancelEditingProfile={this.props.cancelEditingProfile}
            edited={this.props.edited}
            stopEditing={this.props.stopAll}
            containerIsValid={this.props.containerIsValid}
            hasPendingProfile={this.props.hasPendingProfile}
            showProfileLockedModal={this.props.showProfileLockedModal}
            hideProfileLockedModal={this.props.hideProfileLockedModal}
            contactAdviser={this.contactAdviser}
            showModal={this.props.showModal}
          />
        </ErrorBoundary>
      </Col>
    </Row>
  }
}

const mapStateToProps = ({ adviserProfileEditorContainer, administrationLoginContainer }) => {
  return {
    adviserId: adviserProfileEditorContainer.adviserId,
    profile: adviserProfileEditorContainer.profile,
    hasPendingProfile: adviserProfileEditorContainer.hasPendingProfile,
    agToken: adviserProfileEditorContainer.agToken,
    adviserIsLoggedIn: adviserProfileEditorContainer.adviserIsLoggedIn,
    administratorIsLoggedIn: administrationLoginContainer.loginSucceeded,
    loading: adviserProfileEditorContainer.loading,
    loginFailed: adviserProfileEditorContainer.loginFailed,
    editingProfile: adviserProfileEditorContainer.editingProfile,
    submitting: adviserProfileEditorContainer.submittingProfile,
    submitted: adviserProfileEditorContainer.submittedProfile,
    edited: adviserProfileEditorContainer.edited,
    fetchedContactNumberTypes: adviserProfileEditorContainer.fetchedContactNumberTypes,
    containerIsValid: adviserProfileEditorContainer.containerIsValid,
    showModal: adviserProfileEditorContainer.showModal
  }
}

const mapDispatchToProps = (dispatch) => {
  const {submit, edit, fetch, login, set} = actions
  return bindActionCreators({
    logAdviserIn: login.logAdviserIn,
    fetchWorkInProgressProfile: fetch.fetch,
    fetchPendingProfile: fetch.fetchPendingProfile,
    editAll: edit.editAll,
    stopAll: edit.stopAll,
    submitProfile: submit.submitProfile,
    cancelEditingProfile: edit.cancelAll,
    fetchContactNumberTypes: fetch.contactNumberTypes,
    showProfileLockedModal: set.showProfileLockedModal,
    hideProfileLockedModal: set.hideProfileLockedModal
  }, dispatch)
}

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  // The route supplies the real adviserId as an own-prop; don't let an undefined
  // value in Redux state override it (the default merge lets state win).
  adviserId: ownProps.adviserId != null ? ownProps.adviserId : stateProps.adviserId
})

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(AdviserProfileEditorContainer)
